export default {
  fontSize: {
    s: '1rem',
    m: '1.5rem',
    l: '2.25rem',
    xl: '4rem',
    xxl: '9rem',
  },
  fontWeight: {
    light: '300',
    regular: '500',
    semiBold: '600',
    bold: '700',
    extraBold: '800',
  },
};
